export default __webpack_public_path__ + "static/media/happets.ee235f09.png";